import ReactGA from "react-ga";

export const initGA = () => {
    ReactGA.initialize('UA-28761981-8');
}

export const gaPageView = (param,GLID) => {
    ReactGA.set({ dimension1: GLID });//company
    ReactGA.pageview(param);
}

export const gaEvent = (event_name,category, action, label, GLID) => {
    ReactGA.set({ dimension1: GLID });//company
 
    ReactGA.event({
        event:event_name,
        category: category,
        action: action,
        label: label,
    });
};